import { useToast, Box, Flex } from '@chakra-ui/react'
import { useParams, useNavigate } from 'react-router-dom'
import React, { useMemo, useState, useCallback } from 'react'

import { useDimensionListQuery } from 'modules/dimensions'
import { Wizard, WizardOutlet, WizardBreadcrumb } from 'components'

import { useFormSubmissionCreateMutation } from '../hooks'
import { FormSubmissionStep, FormSubmissionIntroStep, FormSubmissionFinalStep } from '../containers'

export const FormSubmissionPage = () => {
  const toast = useToast()
  const navigate = useNavigate()
  const { formId } = useParams()
  const dimensions = useDimensionListQuery()
  const [formSubmissionCreate] = useFormSubmissionCreateMutation()

  const steps = useMemo(
    () => [
      {
        name: 'start',
        path: 'inicio',
        label: 'Início',
        element: <FormSubmissionIntroStep />
      },
      ...(dimensions.data || [])?.map(dimension => ({
        path: dimension.name
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[^\w]/g, ''),
        label: dimension.name,
        element: <FormSubmissionStep formId={formId} dimension={dimension} />
      })),
      {
        name: 'end',
        path: 'fim',
        label: 'Fim',
        element: <FormSubmissionFinalStep />
      }
    ],
    [formId, dimensions.data]
  )

  const [data, setData] = useState({
    form: { id: formId },
    answers: {}
  })

  const handleStep = useCallback(
    stepData =>
      setData(prev => ({
        ...prev,
        answers: {
          ...prev.answers,
          ...stepData.answers
        }
      })),
    [setData]
  )
  const handleFinish = useCallback(async () => {
    const formSubmission = { ...data, answers: Object.values(data.answers) }
    const result = await formSubmissionCreate({ formSubmission })
    if (result?.data?.errors?.length) {
      console.error(result.data.errors) // @TODO
      toast({
        status: 'error',
        title: 'Erro ao criar questionário.',
        description: 'Ocorreu um erro a criar questionário'
      })
    } else {
      toast({
        status: 'success',
        title: 'Respostas submetidas.',
        description: 'As suas respostas foram submetidas com sucesso.'
      })
      navigate(`../../relatorios/${result.data.id}`)
    }
  }, [data, toast, navigate, formSubmissionCreate])

  return (
    <Wizard data={data} steps={steps} onStep={handleStep} onFinish={handleFinish}>
      <Box align='center' p={3} borderBottomWidth='1px'>
        <WizardBreadcrumb />
      </Box>
      <Flex flex={1}>
        <WizardOutlet />
      </Flex>
    </Wizard>
  )
}

export default FormSubmissionPage
